// Packages Import
import { memo, useState, useEffect} from "react"
import { Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
	GridToolbarColumnsButton,
	GridToolbarFilterButton,
	GridToolbarExport,
	GridToolbarDensitySelector,
} from "@mui/x-data-grid";

// Project Components
import InfoTable from "../../../UI/Table"
import { CustomAccordion, CustomAccordionDetails, CustomAccordionSummary } from "../../../UI/CustomAccordion";
import {formatDate} from "../../../Util/Util"
import { cmActions } from "../../../../store/CM/CM-slice"

const columnsSettings = [
	{ field: "cmSite", headerName: "CM Site", type: "text", minWidth: 50, flex: 0.5 },
	{ field: "loc", headerName: "Location", type: "text", minWidth: 70, flex: 0.5 },
    { field: "onHand", headerName: "On Hand", type: "text", minWidth: 50, flex: 0.5 },
]

const RRCMQuantityTable = (props) => {
	const dispatch = useDispatch();
	const [RRCMQuantityAccordian, setRRCMQuantityAccordian] = useState(false);
	const rows = useSelector((state) => state.cmState.RRCM_QUANTITY_TABLE)
	const partNum = useSelector((state) => state.cmState.PART_INFO.partNum)
	const columnVisibility = useSelector((state) => state.cmState.tableColumnVisibilityRRCMQuantity)

	const customToolBar = () => (
		<>
			<GridToolbarColumnsButton />
			<GridToolbarFilterButton />
			<GridToolbarDensitySelector />
			<GridToolbarExport 
				printOptions={{
					disableToolbarButton: true,
				}} 
				csvOptions={{
					fileName: `CM_RRCMDemand_KPN${partNum}_${formatDate(new Date(), "")}`
				}}
			/>
		</>
	)
	useEffect(() => {
		setRRCMQuantityAccordian(JSON.parse(localStorage.getItem("RRCMQuantityAccordian")));
	}, []);

	// Store Accordion state into browser's local storage
	const accordionClicked = () => {
		window.localStorage.setItem("RRCMQuantityAccordian", !RRCMQuantityAccordian);
		setRRCMQuantityAccordian(!RRCMQuantityAccordian);
	};
	return (
		<CustomAccordion onChange={accordionClicked} expanded={RRCMQuantityAccordian}>
			<CustomAccordionSummary aria-controls="panel1a-content" id="panel1a-header">
				<Typography sx={{ fontWeight: "bold" }}>RRCM Quantity On Hand</Typography>
			</CustomAccordionSummary>
			<CustomAccordionDetails>
			<InfoTable 
				columnsSettings={columnsSettings} 
				rows={rows}
				checkboxSelection = {true}
				customToolBar={customToolBar}
				ExtraProps = {{
					columnVisibilityModel:columnVisibility,
					onColumnVisibilityModelChange:(newModel) =>{
						dispatch(cmActions.setColumnVisibility({columnVisibility:newModel , table:"RRCMQuantity"}));
					}
				}}
				/>
			</CustomAccordionDetails>
		</CustomAccordion>
	
	)
}

export default memo(RRCMQuantityTable)
